import { BuildType } from './ApiService';
import {
    ReferralProgramJoinInput,
    ReferralProgramJoinResultModel,
    ReferralProgramReferralResultModel,
    ReferralProgramStatusModel,
} from '@/apiTypes/ReferralProgramTypes';

export const referralProgramService = (build: BuildType) => ({
    getReferralProgramStatus: build.query<ReferralProgramStatusModel, void>({
        query: () => 'referral-program/status',
        providesTags: ['ReferralProgram'],
    }),
    joinReferralProgram: build.mutation<ReferralProgramJoinResultModel, ReferralProgramJoinInput | void>({
        query: body => ({
            url: 'referral-program/join',
            method: 'POST',
            body: body ?? {},
        }),
    }),
    referFriend: build.mutation<
        ReferralProgramReferralResultModel,
        { friendEmail: string; firstName?: string; lastName?: string }
    >({
        query: body => ({
            url: 'referral-program/referrals',
            method: 'POST',
            body,
        }),
    }),
});
